<template>
  <Transition mode="out-in"
              enter-from-class=""
              enter-active-class="fade"
              enter-to-class="show"
              leave-from-class="show"
              leave-active-class="fade"
              leave-to-class="">
    <div v-show="localActive"
         class="tab-pane"
         :class="{ active: localActive }"
         role="tabpanel"
         :id="id"
         :aria-hidden="localActive ? 'false' : 'true'"
         :aria-labelledby="buttonId"
         ref="panel">
      <slot v-if="localActive || !lazy"/>
    </div>
  </Transition>
</template>

<script setup>
// Replaces bootstrap-vue's <b-tab> with the same markup and behaviour (only what the app uses, see
// __tests__/bootstrap/bTabs.test.js). Reference: node_modules/bootstrap-vue/src/components/tabs/tab.js
import { inject, onBeforeUnmount, onMounted, reactive, ref, toRef, watch } from "vue"
import { nextId } from "@/components/bootstrap/uid"

defineOptions({
  name: 'BTab',
})

const props = defineProps({
  title: {
    type: String,
    default: null
  },
  // asks to be the active tab: at first render, and again whenever it changes
  active: {
    type: Boolean,
    default: false
  },
  // the content exists only while the tab is active
  lazy: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['update:active'])

const id = nextId('tab')
const buttonId = `${id}___BV_tab_button__`

const bvTabs = inject('bvTabs', null)
const panel = ref(null)

// what BTabs knows about this tab; BTabs switches localActive
const tab = reactive({
  id,
  buttonId,
  title: toRef(props, 'title'),
  localActive: props.active,
  el: panel,
})
const localActive = toRef(tab, 'localActive')

watch(() => props.active, (newValue, oldValue) => {
  if(newValue === oldValue || !bvTabs) return
  if(newValue) {
    bvTabs.activateTab(tab)
  } else if(!(tab.localActive && bvTabs.deactivateTab(tab))) {
    emit('update:active', tab.localActive)
  }
})

watch(localActive, (newValue) => {
  emit('update:active', newValue)
})

onMounted(() => {
  if(bvTabs) bvTabs.registerTab(tab)
})

onBeforeUnmount(() => {
  if(bvTabs) bvTabs.unregisterTab(tab)
})
</script>
